import type { FetchAllowedClientsListParams } from 'Services/ServiceProviderManagement/Features/AllowedClient/types'
import { createBaseApi } from 'Util/ApiClient'
import { RTKCacheTags } from 'Util/constants'

enum TagTypes {
  ALLOWED_CLIENT = 'AllowedClient'
}

export const allowedClientApi = createBaseApi({
  reducerPath: 'allowedClientApi',
  keepUnusedDataFor: 5,
  tagTypes: [TagTypes.ALLOWED_CLIENT]
}).injectEndpoints({
  endpoints: builder => ({
    // biome-ignore lint/suspicious/noConfusingVoidType: RTK query requires void type for no params
    getAllowedClients: builder.query<string[], FetchAllowedClientsListParams | void>({
      query: params => ({
        url: '/api/v1/spm-allowed-client/',
        params: params ?? undefined
      }),
      providesTags: [{ type: TagTypes.ALLOWED_CLIENT, id: RTKCacheTags.LIST }]
    })
  })
})

export const { useGetAllowedClientsQuery } = allowedClientApi
